import { render, staticRenderFns } from "./member_meal_new.vue?vue&type=template&id=aaa95030&scoped=true"
import script from "./member_meal_new.vue?vue&type=script&lang=js"
export * from "./member_meal_new.vue?vue&type=script&lang=js"
import style0 from "./member_meal_new.vue?vue&type=style&index=0&id=aaa95030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa95030",
  null
  
)

export default component.exports